var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"main-layout",class:_vm.showScrollbar || _vm.isMenuVisible ? 'main-layout--with-scrollbar' : '',attrs:{"no-body":""}},[_c('TheNavbar',{on:{"change":function (visible) { return _vm.isMenuVisible = visible; }}}),_vm._v(" "),_c('b-card-body',{staticStyle:{"line-height":"18px"}},[_c('router-view',{attrs:{"show-scrollbar":_vm.showScrollbar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb67ea5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = INsQ
// module chunks = 1